import { render, staticRenderFns } from "./dataShare.vue?vue&type=template&id=a2384a1a&scoped=true"
import script from "./dataShare.vue?vue&type=script&lang=js"
export * from "./dataShare.vue?vue&type=script&lang=js"
import style0 from "./dataShare.vue?vue&type=style&index=0&id=a2384a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2384a1a",
  null
  
)

export default component.exports